// extracted by mini-css-extract-plugin
export default {"title":"DepositSlipModal_title__iiMxz","description":"DepositSlipModal_description__5xXPh","buttonOkay":"DepositSlipModal_buttonOkay__lub9o"};